import {
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_734'),
      }),
      getCopyWithContentTableColumn({
        field: 'invoice_info_str',
        title: i18n.t('scope.text_282'),
        minWidth: 120,
      }),
      getCopyWithContentTableColumn({
        field: 'invoice_addr_str',
        title: i18n.t('scope.text_735'),
        minWidth: 120,
      }),
      {
        field: 'status',
        title: i18n.t('scope.text_426'),
        minWidth: 70,
        formatter: ({ row, cellValue }) => {
          const obj = {
            init: i18n.t('scope.text_427'),
            open: i18n.t('scope.text_736'),
            submit: i18n.t('scope.text_737'),
            print: i18n.t('scope.text_738'),
            sent: i18n.t('scope.text_739'),
            recv: i18n.t('scope.text_740'),
            cancel: i18n.t('scope.text_523'),
            revoke: i18n.t('scope.text_741'),
            revoke_fail: i18n.t('scope.text_742'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'invoice_no',
        title: i18n.t('scope.text_743'),
        minWidth: 120,
      },
      {
        field: 'invoice_code',
        title: i18n.t('scope.text_744'),
        minWidth: 120,
      },
      getCopyWithContentTableColumn({
        field: 'trace_no',
        title: i18n.t('scope.text_745'),
        minWidth: 120,
      }),
    ]
  },
}
